import React, { useState } from 'react';
import ChampionPoolManager from './ChampionPoolManager';
import ChampionCoachingView from './ChampionCoachingView';
import ChampionsDataView from './ChampionsDataView';

/**
 * APEX v8.13 — ChampionsTabContent
 *
 * Onglet "Champions" du menu principal, avec 3 sous-onglets :
 *   - DONNÉES   : stats par champion (selector, KPIs, matchups, synergies)
 *   - POOL      : gestion drag&drop Main/Flex/Sidelined
 *   - COACHING  : tags Porofessor + analyse du pool
 *
 * Extrait de App.jsx v8.13 (était défini inline).
 */
export default function ChampionsTabContent({ games, filteredGames, champions, version, userSettings, updateChampionPool, handlePoolSuggestion }) {
  const [subTab, setSubTab] = useState('data'); // 'pool' | 'data'

  return (
    <div className="space-y-6">
      {/* Sous-onglets */}
      <div className="flex items-center gap-1 border-b border-zinc-800">
        <button
          onClick={() => setSubTab('data')}
          className={`px-4 py-2.5 text-xs font-bold tracking-wider transition border-b-2 -mb-px ${
            subTab === 'data'
              ? 'border-cyan-400 text-cyan-400'
              : 'border-transparent text-zinc-500 hover:text-zinc-300'
          }`}
        >
          DONNÉES
        </button>
        <button
          onClick={() => setSubTab('pool')}
          className={`px-4 py-2.5 text-xs font-bold tracking-wider transition border-b-2 -mb-px ${
            subTab === 'pool'
              ? 'border-cyan-400 text-cyan-400'
              : 'border-transparent text-zinc-500 hover:text-zinc-300'
          }`}
        >
          POOL
        </button>
        <button
          onClick={() => setSubTab('coaching')}
          className={`px-4 py-2.5 text-xs font-bold tracking-wider transition border-b-2 -mb-px ${
            subTab === 'coaching'
              ? 'border-cyan-400 text-cyan-400'
              : 'border-transparent text-zinc-500 hover:text-zinc-300'
          }`}
        >
          COACHING
        </button>
      </div>

      {/* Contenu */}
      {subTab === 'coaching' && (
        <ChampionCoachingView
          games={games}
          userSettings={userSettings}
        />
      )}
      {subTab === 'pool' && (
        <ChampionPoolManager
          games={games}
          userSettings={userSettings}
          champions={champions}
          version={version}
          onUpdatePool={updateChampionPool}
          onSuggestObjective={handlePoolSuggestion}
        />
      )}
      {subTab === 'data' && (
        <ChampionsDataView
          games={filteredGames}
          champions={champions}
          version={version}
        />
      )}
    </div>
  );
}
